// @generated by js/design-system/build/controller-manifest.js
export const lpControllerManifest = {
    "lp-data-table": () => import("../blocks/data-table/data-table.controller"),
    "lp-module-grid": () => import("../blocks/module-grid/module-grid.controller"),
    "lp-collapsible": () => import("../components/collapsible/collapsible.controller"),
    "lp-dropdown": () => import("../components/dropdown/dropdown.controller"),
    "lp-popover": () => import("../components/popover/popover.controller"),
    "lp-tooltip": () => import("../components/tooltip/tooltip.controller"),
};
